export default __webpack_public_path__ + "static/media/house_eight.d7cda664.jpg";